import { FC, useEffect } from 'react';

import useJoiValidation from '../../hooks/useJoiValidation';
import { IVedioKeyCompProps } from './models';
import { VedioKeyCompSchema } from './VedioKeyComp.schema';

import './VedioKeyComp.scss';

const VedioKeyComp: FC<IVedioKeyCompProps> = ({ optClassName }) => {
  const {
    data,
  }: {
    data: IVedioKeyCompProps;
  } = useJoiValidation(VedioKeyCompSchema, 'VedioKeyComp', {
    optClassName,
  });

  useEffect(() => {
    const playBtn = document.querySelector('.cds-video__wrapper .cds-video__btn_wrapper .cds-btn');

    if (!playBtn) {
      return;
    }

    const handleClick = () => {
      setTimeout(() => {
        const iframe = document.querySelector('.cds-video__frame');
        const src = iframe?.attributes.getNamedItem('src')?.value;
        if (src?.startsWith('https://www.youtube-nocookie.com')) {
          if (iframe) {
            iframe.className =
              data.optClassName || 'optanon-category-C0004 ot-vscat-C0004 cds-video__frame';
          }
        }
      });
    };

    playBtn.addEventListener('click', handleClick);
  }, [data.optClassName]);

  return null;
};
export default VedioKeyComp;
